import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import FileUpload from '../components/FileUpload'; 
import UrlUpload from '../components/UrlUpload'; 
import FileList from '../components/FileList'; 
import '../styles/Documents.css';

function Documents() {
  const { language } = useLanguage();
  const [activeTab, setActiveTab] = useState('upload'); 

  return (
    <div className="documents-container">
      <h1 className="documents-header">
        {language === 'en' ? 'Data Room' : 'Datenraum'}
      </h1>
      <p className="documents-description">
        {language === 'en' ? (
          <>
            Share documents safely with us. You can also mark them as sensitive to restrict access 
            to only those who have sensitive access.
          </>
        ) : (
          <>
            Teilen Sie Dokumente sicher mit uns. Sie können sie auch als sensibel markieren, um den Zugriff 
            auf Personen mit sensiblen Zugriffsrechten zu beschränken.
          </>
        )}
      </p>

      <hr className="section-divider" />

      {/* Tabs Container */}
      <div className="tabs-container">
        <div 
          className={`tab-item ${activeTab === 'upload' ? 'active' : ''}`}
          onClick={() => setActiveTab('upload')}
        >
          {language === 'en' ? 'Upload Documents' : 'Dokumente hochladen'}
        </div>
        <div 
          className={`tab-item ${activeTab === 'urls' ? 'active' : ''}`}
          onClick={() => setActiveTab('urls')}
        >
          {language === 'en' ? 'Share URLs' : 'URLs teilen'}
        </div>
      </div>


      {activeTab === 'upload' && <FileUpload />}
      {activeTab === 'urls' && <UrlUpload />}

      <FileList />
    </div>
  );
}

export default Documents;
